import { useState, useEffect } from 'react';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useTranslation } from 'react-i18next';
import UserAddressService from '../../services/useraddress/useraddress.service';
import AddDistrict from './district-add';
import { DistrictDTOModel } from '../../models/cust-address/cust-address-model';
import '../../assests/css/common/responsive-ui.css';

interface SearchPanelProps {
  reloadPage: (value: boolean) => void;
  setLoading: (loading: boolean) => void;
  pageNumber: number; 
  pageSize: number; 
  setPageNumber: (pageNumber: number) => void;
  setPageSize: (pageSize: number) => void;
  setDistrictList: (district: DistrictDTOModel[]) => void;
  setTotalRecords: (total: number) => void;
  setSearchTerm: (searchTerm: string) => void;
  searchTerm: string; 
}

const DistrictSearch: React.FC<SearchPanelProps> = ({
  reloadPage,
  setLoading,
  pageNumber, 
  pageSize, 
  setPageNumber,
  setPageSize,
  setDistrictList,
  setTotalRecords,
  setSearchTerm,
  searchTerm: propSearchTerm, 
}) => {
  const { t } = useTranslation();
  const [localSearchTerm, setLocalSearchTerm] = useState(propSearchTerm || '');
  const [showAddModal, setShowAddModal] = useState(false);
  const [searchTimeout, setSearchTimeout] = useState<NodeJS.Timeout | null>(null);
  
  useEffect(() => {
    setLocalSearchTerm(propSearchTerm || '');
  }, [propSearchTerm]);

  const handleSearchChange = (value: string) => {
    setLocalSearchTerm(value);
    
    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }
    
    const newTimeout = setTimeout(() => {
      setPageNumber(1);
      setSearchTerm(value);
    }, 300);
    
    setSearchTimeout(newTimeout);
  };

  const handleReset = () => {
    setLocalSearchTerm('');
    setPageNumber(1);
    setPageSize(10);
    setSearchTerm('');
  };

  useEffect(() => {
    return () => {
      if (searchTimeout) {
        clearTimeout(searchTimeout);
      }
    };
  }, [searchTimeout]);

  return (
    <div className="col-12">
      <div className="card border-noround p-2" style={{ minHeight: '3.5rem' }}>
        <div className="input-container font-bold text-white border-round" style={{ float: "left", width: "18%" }}>
          <div className="p-input-icon-left">
            <i className="pi pi-search" />
            <InputText
              type="search"
              value={localSearchTerm}
              onChange={(e) => handleSearchChange(e.target.value)}
              placeholder="Keyword Search"
              style={{ width: "100%" }}
            />
          </div>
        </div>

        <div className="buttons-container">
          <div className="filter-button font-bold text-white border-round ml-2" style={{ float: "left", textAlign: 'right', width: "10%" }}>
            <Button
              className="text-black border-round"
              style={{ width: "100%", textAlign: 'center' }}
              onClick={handleReset}
              severity="success"
            >
              Reset
            </Button>
          </div>
          <div className="add-button-container border-round font-bold ml-3 text-primary" style={{ textAlign: 'right' }}>
            <Button
              className="bg-green-700 border-round p-button p-button-text p-component text-center text-white"
              style={{ textAlign: 'center' }}
              onClick={() => setShowAddModal(true)}
              severity="secondary"
              text
              raised
            >
              Add
            </Button>
          </div>
        </div>

        {showAddModal && (
          <AddDistrict 
            showDistrictDialog={showAddModal}
            hideDistrictDialog={() => setShowAddModal(false)}
            handleAddSuccess={() => {
              setShowAddModal(false);
              reloadPage(true);
            }}
          />
        )}
      </div>
    </div>
  );
};

export default DistrictSearch;